/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    MoyaEventHandler.on('ext.mobilemenu.init', function (e) {
        var mobileQn = document.querySelector('ul.mobileQn');
        if (!mobileQn) {
            return;
        }
        var desButton = document.querySelector('.des_qn > button');
        mobileQn.classList.remove('mmLevel1');
        mobileQn.classList.add('mmLevel2');
        var navbar = document.createElement('div');
        navbar.classList.add('navbar');
        var navBarHome = document.createElement('a');
        navBarHome.href = '#';
        navBarHome.classList.add('home');
        navBarHome.innerHTML = '<span class="sr-only">Heim</span>';
        navbar.appendChild(navBarHome);
        var header = document.createElement('div');
        header.classList.add('header');
        var headerBack = document.createElement('a');
        headerBack.classList.add('back');
        headerBack.href = '/' + desButton.dataset.currentDivision;
        headerBack.innerHTML = '<span>' + desButton.dataset.currentDivisionName + '</span>';
        header.appendChild(headerBack);
        mobileQn.prepend(header);
        mobileQn.prepend(navbar);
        var mobileLevel1 = document.querySelector('#mobilemenu ul.mmLevel1');
        var button = document.createElement('button');
        button.classList.add('expand');
        button.setAttribute('aria-label', 'Opna/loka');
        var anchorLabel = document.createElement('span');
        anchorLabel.innerHTML = desButton.innerText;
        var anchor = document.createElement('a');
        anchor.href = '/' + desButton.dataset.currentDivision;
        anchor.appendChild(anchorLabel);
        var qnLiItem = document.createElement('li');
        qnLiItem.classList.add('level1');
        qnLiItem.classList.add('children');
        qnLiItem.appendChild(button);
        qnLiItem.appendChild(anchor);
        qnLiItem.appendChild(mobileQn);
        mobileLevel1.appendChild(qnLiItem);
        Array.prototype.forEach.call(qnLiItem.querySelectorAll('.expand'), function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                el.closest('li').classList.toggle('down');
            });
        });
        util.delegate(headerBack, 'click', 'body', function (e) {
            e.preventDefault();
            mobileQn.parentElement.classList.remove('down');
        });
        util.delegate(navBarHome, 'click', 'body', function (e) {
            e.preventDefault();
            mobileQn.parentElement.classList.remove('down');
        });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
